<card name="Form groups">
  <div card content>
    <div class="row">
      <div class="col-60">
        <form [formGroup]="form">
          <p>Type property age: {{ typeof(form.get('age').value) | json }}</p>
          <form-group-simple class="d-block mb-2" inputType="number" formControlName="age" placeholder="Enter the age"></form-group-simple>

          <form-group-select class="d-block mb-2" formControlName="country"
                             [items]="mockUpCountries" bindLabel="title" bindValue="id" placeholder="Country">
          </form-group-select>

          <form-group-context label="Name" formControlName="name">
            <form-group-simple placeholder="Enter the Name"></form-group-simple>
          </form-group-context>

          <form-group-context label="Description" formControlName="description">
            <form-group-simple type="textarea" placeholder="Enter the Description"></form-group-simple>
          </form-group-context>

          <form-group-context label="Birth Day" formControlName="birthday">
            <form-group-date [single]="true" placeholder="Select your date"></form-group-date>
          </form-group-context>

          <form-group-context label="Active" formControlName="active">
            <form-group-simple type="checkbox"></form-group-simple>
          </form-group-context>

          <form-group-context label="Role" formControlName="role">
            <form-group-select [items]="mockUpRoles" bindLabel="title" bindValue="id" placeholder="Role"></form-group-select>
          </form-group-context>

          <form-group-context label="Files" formControlName="files">
            <form-group-files [single]="true"></form-group-files>
          </form-group-context>

          <form-group-context label="Control" formControlName="control" *ngIf="form.get('control')">
            <form-group-simple placeholder="Enter the Name"></form-group-simple>
          </form-group-context>

          <form-group-context label="Name Control" formControlName="nameControl" *ngIf="form.get('nameControl')">
            <form-group-simple placeholder="Enter the Name"></form-group-simple>
          </form-group-context>

          <form-group-context label="City" formControlName="city" *ngIf="form.get('city')">
            <form-group-simple placeholder="Enter the City"></form-group-simple>
          </form-group-context>
        </form>
      </div>

      <div class="col-60">
        <div class="small text-muted">
          <p>valid: {{ form.valid | json }}</p>
          <p>error: {{ form.errors | json }}</p>
          <p>pristine: {{ form.pristine | json }}</p>
          <p>dirty: {{ form.dirty | json }}</p>
          <p>touched: {{ form.touched | json }}</p>
          <p>untouched: {{ form.untouched | json }}</p>
        </div>
      </div>
    </div>

    <div class="mt-4 small text-muted">
      {{ form.value | json }}
    </div>

    <button class="btn btn-primary mt-5 mr-5" type="button" (click)="validate()">Validate</button>
    <button class="btn btn-primary mt-5 mr-5" type="button" (click)="setData()">Set data</button>
    <button class="btn btn-primary mt-5 mr-5" type="button" (click)="toggleDisabled()">Toggle disabled</button>
    <button class="btn btn-primary mt-5" type="button" (click)="checkChanges()">Check changes</button>
  </div>
</card>
